/**
 * Returns the trial duration by looking at the number of days left.
 * If the trial has ended, it will display a message indicating that.
 * If the trial ends today, it will indicate that.
 * Otherwise, it will show the number of days left until the trial ends.
 */
export function getTrialEndingNotice(props: {
    daysLeft: number | undefined;
    prefix?: string;
}): string {
    const { daysLeft, prefix = '' } = props;
    const prefixStr = prefix ? `${prefix} ` : '';
    if (daysLeft === undefined || daysLeft === 0) {
        return `Your ${prefixStr}trial has ended`;
    }

    if (daysLeft === 1) {
        return `Your ${prefixStr}trial ends today`;
    }

    return `Your ${prefixStr}trial ends in ${daysLeft} days`;
}
